import { useQuery } from '@tanstack/react-query';

import { Skeleton } from '@/components/ui/skeleton';
import type { Project } from '@/lib/queries/project';
import { resourceQueries } from '@/lib/queries/resource';

import { Timeline } from './Timeline';

export const ResourceHistory = ({
  hashedID,
  mainProject,
  from,
  to,
}: {
  hashedID: string;
  mainProject: Project;
  from?: string;
  to?: string;
}): JSX.Element => {
  const { data, isPending, isError } = useQuery(
    resourceQueries.history(mainProject.id, hashedID),
  );

  if (isPending) {
    return (
      <div className="space-y-4 mb-16">
        <Skeleton className="h-8 w-60 bg-background mb-8" />
        <Skeleton className="h-6 w-full bg-background" />
        <Skeleton className="h-6 w-full bg-background" />
        <Skeleton className="h-6 w-full bg-background" />
      </div>
    );
  }

  if (isError) {
    return <p>Failed to get history data for this resource...</p>;
  }

  return (
    <div>
      <Timeline history={data} from={from} to={to} />
    </div>
  );
};
